export const colors = <const>{
  white: '#fff',
  black: '#222',
  green: '#D9E200',
  grey: '#9C9C9C',
  alto: '#DBDBDB',
};

export type ColorNames = keyof typeof colors;